import styled, { AnyStyledComponent } from 'styled-components';
import FONTS from '../../style/fonts';
import COLORS from '../../style/universal.color'
import Button from '../Button/button';

export interface WrapperProps {
  theme: {
    dark: boolean;
  };
  isInvalid: boolean;
}

export const Wrapper: AnyStyledComponent = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  height: 32px;
  padding: 0 32px 0 10px;
  box-sizing: border-box;
  background-color: ${({ theme }: WrapperProps) => theme.dark ? COLORS.mlbGrey6 : COLORS.mlbWhite};
  border: 1px solid ${({ isInvalid, theme }: WrapperProps) => {
    if(!isInvalid) {
      return COLORS.mlbGrey6;
    }
    return theme.dark ? COLORS.inputInvalidOnDark : COLORS.inputInvalid;
  }};
  border-radius: 5px;
  color: ${COLORS.mlbGrey3};
  font-family: ${FONTS.primaryFont};
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
  cursor: text;
`;

export const InnerInputs: AnyStyledComponent = styled.span``;

export const Input: AnyStyledComponent = styled.input`
  border: 0;
  padding: 0 0 0 5px;
  margin: 0;
  background-color: ${COLORS.transparent};
  color: ${({ theme }) => theme.dark ? COLORS.mlbWhite : COLORS.mlbGrey6};
  font-family: ${FONTS.primaryFont};
  font-size: 15px;
  font-variant: tabular-nums lining-nums;
  height: 30px;
  line-height: 30px;
  ${({ placeholder }) => placeholder && `
    box-sizing: content-box;
    width: calc(${placeholder.length}ch + 10px);
  `}

  &:focus {
    outline: none;
  }

  ::placeholder {
    color: ${COLORS.mlbGrey3};
  }
`;

export const Divider: AnyStyledComponent = styled.span``;

export const ResetBtn: AnyStyledComponent = styled(Button)`
  position: absolute;
  top:0;
  right: 0;
  height: 30px;
`;

export const ErrorMsg: AnyStyledComponent = styled.div`
  margin: 2px 16px;
  color: ${({ theme }: WrapperProps) => theme.dark ? COLORS.inputInvalidOnDark : COLORS.inputInvalid};
  font-family: ${FONTS.primaryFont};
  font-size: 12px;
`;
